export default "__VITE_ASSET__BKJzcLlU__"